import React from "react";
import { Badge, Modal, Table } from "components/ui/BootstrapCompat";
import { useQuery } from "react-query";
import { gamePackageGetMany } from "services/game.service";
import useLocalStorage from "helpers/useLocalStorage";

interface PopUpGamePackageProps {
  game: any;
  businessId?: string;
  open: boolean;
  onClose: () => void;
}

export default function PopUpGamePackage({
  game,
  businessId,
  open,
  onClose,
}: PopUpGamePackageProps) {
  const [token] = useLocalStorage("token", "");

  const { data, isLoading, refetch } = useQuery(
    ["game-package-get-many", game?._id, businessId],
    async () => {
      return await gamePackageGetMany({
        findby: { productAgentId: game._id },
        token: token || "",
        businessId: businessId || "",
      });
    },
    {
      enabled: !!game?._id && !!open && !!businessId,
    },
  );

  const packages: any[] = data || [];

  const formatCurrency = (amount: number) =>
    new Intl.NumberFormat("lo-LA").format(amount);

  return (
    <Modal show={open} onHide={onClose} keyboard={false} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>
          <div className="flex gap-2 items-center">
            <span className="material-icons">inventory_2</span>
            ແພັກເກດຂອງ: {game?.name || "--"}
          </div>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-0">
        <div className="flex items-center justify-between gap-2 border-b bg-white p-3 text-sm text-gray-500">
          <span>ລາຍການລາຄາແພັກເກດແມ່ນເບິ່ງໄດ້ຢ່າງດຽວ</span>
          <button
            type="button"
            className="btn btn-outline-primary btn-sm"
            onClick={() => refetch()}
          >
            Refetch
          </button>
        </div>
        {isLoading ? (
          <div className="py-8 text-center text-gray-500">
            ກຳລັງໂຫລດຂໍ້ມູນ...
          </div>
        ) : packages.length === 0 ? (
          <div className="py-8 text-center text-gray-500">ບໍ່ມີແພັກເກດ</div>
        ) : (
          <Table striped bordered hover size="sm" className="mb-0">
            <thead>
              <tr>
                <th className="py-2 px-3 w-[50px]">ລ/ດ</th>
                <th className="py-2 px-3">ຊື່ແພັກເກດ</th>
                <th className="py-2 px-3 text-center">ລາຄາ (ກີບ)</th>
                <th className="py-2 px-3 text-center">ສະຖານະ</th>
              </tr>
            </thead>
            <tbody>
              {packages.map((pkg: any, i: number) => (
                <tr key={pkg._id || i}>
                  <td className="py-2 px-3">{i + 1}</td>
                  <td className="py-2 px-3">
                    <div className="font-bold text-primary">
                      {pkg?.name || pkg?.title || pkg?.packageGame || "--"}
                    </div>
                    {pkg?.description && (
                      <div className="text-[11px] text-gray-500">
                        {pkg.description}
                      </div>
                    )}
                    {pkg?._id && (
                      <div className="text-[10px] text-neutral-400">
                        ID: {pkg._id}
                      </div>
                    )}
                  </td>
                  <td className="py-2 px-3 text-center">
                    {pkg?.price !== undefined
                      ? formatCurrency(pkg.price)
                      : "--"}
                  </td>
                  <td className="py-2 px-3 text-center">
                    <Badge>
                      {pkg?.active === "PUBLIC" ? "ເປຶດໃຊ້ງານ" : "ປິດໃຊ້ງານ"}
                    </Badge>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </Modal.Body>
      <Modal.Footer className="text-sm text-gray-500">
        ທັງໝົດ {packages.length} ແພັກເກດ
      </Modal.Footer>
    </Modal>
  );
}
